module.exports = __webpack_public_path__ + "img/home-button.4da16ee0.gif";